import {Grid} from '@yandex-delivery/blocks'
import {noop} from '@yandex-delivery/utils'
import clsx from 'clsx'
import React, {memo} from 'react'
import i18n from 'src/shared/i18n'

import {classes} from './styles'
import type {PromoBaseProps} from './types'

const YangoPromo: React.FC<PromoBaseProps> = props => {
  const {
    title = i18n.print('route_install_yango'),
    text = i18n.print('route_promo_text'),
    link = 'https://apps.apple.com/app/id1437157286',
    fullWidth = false,
    onClick = noop,
  } = props

  return (
    <a className={clsx(classes.container, classes.containerYango)} href={link} onClick={onClick}>
      <Grid container justify="space-around">
        <Grid className={clsx(fullWidth && classes.adaptiveGrid)} item xs={9}>
          <div className={classes.title}>{title}</div>
          <div className={classes.text}>{text}</div>
        </Grid>
        <Grid item>
          <div className={clsx(classes.icon, classes.iconYango, fullWidth && classes.fullWidthIcon)} />
        </Grid>
      </Grid>
    </a>
  )
}

export default memo(YangoPromo)
